import { z } from 'zod'

export const ADMINAGENTSGET_CONTRACT_VERSION = '1.0.0' as const
export const adminAgentsGetResponseSchema = z.unknown()
export type AdminAgentsGetResponse = z.infer<typeof adminAgentsGetResponseSchema>
